import { Position } from '@/services/hooks/template_attributes'
import { LETTER_PAGE_HEIGHT } from '../DocumentTemplate'

export const calculateLineValues = ({
  startPoint,
  endPoint,
}: {
  startPoint: Position
  endPoint: Position
}) => {
  const lineSize = Math.sqrt(
    Math.pow(endPoint.x - startPoint.x, 2) +
      Math.pow(endPoint.y - startPoint.y, 2),
  )
  const slope = (endPoint.y - startPoint.y) / (endPoint.x - startPoint.x)
  const direction = endPoint.x < startPoint.x ? 'left' : 'right'
  let inclination = Math.atan(slope) * (180 / Math.PI)

  if (direction === 'left') {
    inclination = (180 - inclination) * -1
  }

  return {
    lineSize,
    inclination,
  }
}

export const isArrow = (type: string) =>
  type === 'arrow' || type.includes('bubble') || type.includes('arrow')
export const isLine = (type: string) => type === 'line' || isArrow(type)

export const getAbsoluteYFromSubPage = ({
  subPageId,
  relativeY,
  subPageIds,
  isRelative,
  relativeOffset = 0,
}: {
  subPageId: string
  relativeY: number
  subPageIds: string[]
  isRelative?: boolean
  relativeOffset?: number
}) => {
  const offSet = isRelative ? relativeOffset : 0
  const index = subPageIds.indexOf(subPageId)
  if (index <= 0) return relativeY + offSet

  return 614 - 64 + (index - 1) * 614 + relativeY + offSet
}

export const getAbsoluteXFromDocumentPageOrder = ({
  documentPageOrder,
  relativeX,
  isRelative,
  relativeOffset = 0,
}: {
  documentPageOrder?: number | null
  relativeX: number
  isRelative?: boolean
  relativeOffset?: number
}) => {
  const offSet = isRelative ? relativeOffset * (documentPageOrder || 0) : 0

  return relativeX + offSet
}

export const getSubPageIndexFromAbsoluteY = (absoluteY: number) => {
  if (absoluteY < LETTER_PAGE_HEIGHT - 64) return 0
  return (
    1 + Math.floor((absoluteY - (LETTER_PAGE_HEIGHT - 64)) / LETTER_PAGE_HEIGHT)
  )
}

export const getRelativeY = (absoluteY: number) => {
  if (absoluteY < LETTER_PAGE_HEIGHT - 64) return absoluteY
  return (absoluteY - (LETTER_PAGE_HEIGHT - 64)) % LETTER_PAGE_HEIGHT
}
